import { Box, Divider, Flex } from '@chakra-ui/react';
import BEIcon from '@molecules/BEIcon';
import Text from '@molecules/Text';

import * as DOMPurify from 'dompurify';
import { useMemo } from 'react';

interface BankTransferInstructionsProps {
  instructions?: string;
}

const BankTransferInstructions = (props: BankTransferInstructionsProps) => {
  const htmlData = useMemo(
    () => DOMPurify.sanitize(props.instructions || ''),
    [props.instructions]
  );

  return (
    <Box
      mt="25px"
      width="100%"
      borderWidth="1px"
      borderRadius="16px"
      overflow="hidden"
    >
      <Flex
        gap={3}
        height="56px"
        justifyContent="space-between"
        alignItems="center"
        px="16px"
      >
        <Text type="h3" weight="500">
          Bank Transfer Instructions
        </Text>
        <BEIcon name={'university'} size="xl" weight="light" />
      </Flex>
      <Divider />
      <Box p="16px">
        <Box dangerouslySetInnerHTML={{ __html: htmlData }}></Box>
      </Box>
    </Box>
  );
};

export default BankTransferInstructions;
